// extracted by mini-css-extract-plugin
export default {"wrapperNoData":"NoDataAvailable_wrapperNoData__w78AE"};